import React, { useState } from "react";
import { useAsyncEffect } from "@react-hook/async";
import moment from "moment";
import { fetchRepoInfo, fetchLatestReleaseInfo } from "../../../api";
import GitHubStar from "../assets/GitHubStar.png";
import GitHubTag from "../assets/GitHubTag.png";
import styled from "styled-components";

const RepoInfoText = styled.div`
  font-size: var(--global-font-size-s);
  margin-top: var(--global-spacing-l);
  color: var(--indigo7);
`;

const LinkDark = styled.a`
  color: var(--indigo7);
  :hover {
    color: var(--dark-link-color-hover);
  }
`;

const MiniIconImg = styled.img`
  height: var(--global-font-size-s);
  margin-right: var(--global-spacing-s);

  &:not(:first-child) {
    margin-left: var(--global-spacing-m);
  }
`;

const SemgrepRepoInfo: React.FC<{}> = () => {
  // Get stars
  const [starCount, setStarCount] = useState<number>(NaN);
  const [tagName, setTagName] = useState<string>("");
  const [lastUpdated, setLastUpdated] = useState<string>("");

  useAsyncEffect(async () => {
    fetchRepoInfo("returntocorp", "semgrep").then((repoInfo) => {
      const starCount = repoInfo.stargazers_count;
      if (!!starCount && !isNaN(starCount)) {
        setStarCount(starCount);
      }
    });
  }, []);

  useAsyncEffect(async () => {
    fetchLatestReleaseInfo("returntocorp", "semgrep").then((releaseInfo) => {
      setTagName(releaseInfo.tag_name);
      setLastUpdated(releaseInfo.published_at);
    });
  }, []);

  return (
    <RepoInfoText>
      {!isNaN(starCount) && (
        <span data-testid="has-repo-info">
          <MiniIconImg src={GitHubStar} alt="GitHub stars" />{" "}
          <LinkDark href={"https://github.com/returntocorp/semgrep"}>
            {(starCount / 1000).toFixed(1)}k
          </LinkDark>{" "}
        </span>
      )}
      {!!tagName && !!lastUpdated ? (
        <>
          <MiniIconImg src={GitHubTag} alt="Latest GitHub tag" />{" "}
          <LinkDark href="https://github.com/returntocorp/semgrep/releases/">
            {tagName}
          </LinkDark>{" "}
          ({moment(lastUpdated).fromNow()})
        </>
      ) : null}
    </RepoInfoText>
  );
};

export default SemgrepRepoInfo;
